export enum ChannelType {
  /**
   * 竞价预告
   */
  APPLY_ANNOUNCEMENT = 0,
  /**
   * 成交公告
   */
  TRANSACTION_ANNOUNCEMENT = 1
}

export const ChannelTypeTextMap: Record<ChannelType, string> = {
  [ChannelType.APPLY_ANNOUNCEMENT]: '竞价预告',
  [ChannelType.TRANSACTION_ANNOUNCEMENT]: '成交公告'
}
